import { Component, OnInit } from '@angular/core';
import {ConferenceEvent} from '../model/ConferenceEvent';

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.css']
})
export class ProgramComponent implements OnInit {

  plan: ConferenceEvent [] ;

  constructor() { }

  ngOnInit() {
    this.loadPlan();
  }

  public getEventByDay(day: string): ConferenceEvent []{
    return this.plan.filter( e => e.day === day);
  }

  loadPlan() {
    this.plan = [
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:00",
        "dayEventOrderNumber": 0,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Breakfast"
      },
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:50",
        "dayEventOrderNumber": 1,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "OPENING OF THE CONFERENCE"
      },
      {
        "day": "Monday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 2,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE MORNING SESSION (Chair: Grzegorz Banaszak)"
      },
      {
        "day": "Monday",
        "eventType": "LECTURE",
        "time": "9:00 - 10:00",
        "dayEventOrderNumber": 3,
        "speaker": "Helmut Ahammer",
        "lectureTitle": "Variability of beat to beat contraction strength measured with video recordings",
        "announcement": ""
      },
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 4,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Monday",
        "eventType": "LECTURE",
        "time": "10:30 - 11:30",
        "dayEventOrderNumber": 5,
        "speaker": "Preda Mihailescu",
        "lectureTitle": "Numbers, classes and relations",
        "announcement": ""
      },
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 6,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Lunch break (Lunch served at 12:15)"
      },
      {
        "day": "Monday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 7,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE AFTERNOON SESSION (Chair: Michał Banaszak)"
      },
      {
        "day": "Monday",
        "eventType": "LECTURE",
        "time": "14:30 - 15:30",
        "dayEventOrderNumber": 8,
        "speaker": "Tadeusz Lulek",
        "lectureTitle": "Examples of breaking and enhancing of Galois symmetry of Bethe pseudoparticles in isotropic heptagonal magnetic ring",
        "announcement": ""
      },
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 9,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Monday",
        "eventType": "LECTURE",
        "time": "16:00 - 17:00",
        "dayEventOrderNumber": 10,
        "speaker": "Andrij Rovenchak",
        "lectureTitle": "Bridging biology, linguistics, and physics: Some preliminary results for the distribution of nucleotides in mitochondrial DNA",
        "announcement": ""
      },
      {
        "day": "Monday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 11,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE POSTER SESSION (Chair: Michał Banaszak)"
      },
      {
        "day": "Monday",
        "eventType": "LECTURE",
        "time": "17:15 - 17:30",
        "dayEventOrderNumber": 12,
        "speaker": "Marta Borowska",
        "lectureTitle": "Lempel-Ziv complexity measure in biomedical applications",
        "announcement": ""
      },
      {
        "day": "Monday",
        "eventType": "ANNOUNCEMENT",
        "time": "18:30",
        "dayEventOrderNumber": 13,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Dinner"
      },
      {
        "day": "Tuesday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:00",
        "dayEventOrderNumber": 0,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Breakfast"
      },
      {
        "day": "Tuesday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 1,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE MORNING SESSION (Chair: Preda Mihailescu)"
      },
      {
        "day": "Tuesday",
        "eventType": "LECTURE",
        "time": "9:00 - 10:00",
        "dayEventOrderNumber": 2,
        "speaker": "Andreas Dominik",
        "lectureTitle": "Improving Medical Decisions by Considering Non-Linearity of Biological Signals",
        "announcement": ""
      },
      {
        "day": "Tuesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 3,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Tuesday",
        "eventType": "LECTURE",
        "time": "10:30 - 11:30",
        "dayEventOrderNumber": 4,
        "speaker": "Grzegorz Banaszak",
        "lectureTitle": "Arithmetic Quantum Mechanics and Galois Theory",
        "announcement": ""
      },
      {
        "day": "Tuesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 5,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Lunch break (Lunch served at 12:15)"
      },
      {
        "day": "Tuesday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 6,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE AFTERNOON SESSION  (Chair: Helmut Ahammer)"
      },
      {
        "day": "Tuesday",
        "eventType": "LECTURE",
        "time": "14:30 - 15:30",
        "dayEventOrderNumber": 7,
        "speaker": "Tomasz Pawłowski",
        "lectureTitle": "Loop Quantum Cosmology: from polymer quantization to Early Universe dynamics",
        "announcement": ""
      },
      {
        "day": "Tuesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 8,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Tuesday",
        "eventType": "LECTURE",
        "time": "16:00 - 17:00",
        "dayEventOrderNumber": 9,
        "speaker": "Mihai Tanase",
        "lectureTitle": "On the Collatz conjecture",
        "announcement": ""
      },
      {
        "day": "Tuesday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 10,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE POSTER SESSION (Chair: Nebojsa Milosevic) "
      },
      {
        "day": "Tuesday",
        "eventType": "LECTURE",
        "time": "17:15 - 17:30",
        "dayEventOrderNumber": 11,
        "speaker": "Julia Jelitzki",
        "lectureTitle": "DeepHRV - Discovering fractal properties of HRV series with help of deep neural networks",
        "announcement": ""
      },
      {
        "day": "Tuesday",
        "eventType": "ANNOUNCEMENT",
        "time": "18:30",
        "dayEventOrderNumber": 10,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "The conference dinner"
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:00",
        "dayEventOrderNumber": 0,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Breakfast"
      },
      {
        "day": "Wednesday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 1,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE MORNING SESSION (Chair:  Tadeusz Lulek)"
      },
      {
        "day": "Wednesday",
        "eventType": "LECTURE",
        "time": "9:00 - 10:00",
        "dayEventOrderNumber": 2,
        "speaker": "Piotr Krasoń",
        "lectureTitle": "Application of non-standard analysis to singular solutions of Bethe Ansatz",
        "announcement": ""
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 3,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Wednesday",
        "eventType": "LECTURE",
        "time": "10:30 - 11:30",
        "dayEventOrderNumber": 4,
        "speaker": "Maciej Grześkowiak",
        "lectureTitle": "On generating primes with applications to cryptology",
        "announcement": ""
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 5,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Lunch break (Lunch served at 12:15)"
      },
      {
        "day": "Wednesday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 6,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE AFTERNOON SESSION (Chair: Piotr Krasoń)"
      },
      {
        "day": "Wednesday",
        "eventType": "LECTURE",
        "time": "14:30 - 15:30",
        "dayEventOrderNumber": 7,
        "speaker": "Michał Banaszak",
        "lectureTitle": "Self-assembly of biopolymers and protein-like polymers",
        "announcement": ""
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 8,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Wednesday",
        "eventType": "LECTURE",
        "time": "16:00 - 17:00",
        "dayEventOrderNumber": 9,
        "speaker": "Mirosław Łabuz",
        "lectureTitle": "String hypothesis for short Heisenberg magnets",
        "announcement": ""
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "18:00",
        "dayEventOrderNumber": 10,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Dinner"
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "19:00",
        "dayEventOrderNumber": 11,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Bus to Adam Mickiewicz University in Poznań"
      },
      {
        "day": "Wednesday",
        "eventType": "LECTURE",
        "time": "20:30",
        "dayEventOrderNumber": 12,
        "speaker": "Dorota Blinkiewicz",
        "lectureTitle": "Piano Recital at Adam Mickiewicz University Lubrański Hall",
        "announcement": ""
      },
      {
        "day": "Wednesday",
        "eventType": "ANNOUNCEMENT",
        "time": "21:30",
        "dayEventOrderNumber": 13,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Bus from Poznań to Będlewo"
      },
      {
        "day": "Thursday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:00",
        "dayEventOrderNumber": 0,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Breakfast"
      },
      {
        "day": "Thursday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 1,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE MORNING SESSION (Chair:  Andreas Dominik)"
      },
      {
        "day": "Thursday",
        "eventType": "LECTURE",
        "time": "9:00 - 10:00",
        "dayEventOrderNumber": 2,
        "speaker": "Valery Romanovski",
        "lectureTitle": "Periodic solutions in some biochemical models",
        "announcement": ""
      },
      {
        "day": "Thursday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 3,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Thursday",
        "eventType": "LECTURE",
        "time": "10:30 -  11:30",
        "dayEventOrderNumber": 4,
        "speaker": "Jan Milewski",
        "lectureTitle": "Diagonalisation of the Heisenberg Hamiltonian for two spin deviations and Chebyshev polynomials",
        "announcement": ""
      },
      {
        "day": "Thursday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 5,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Lunch break (Lunch served at 12:15)"
      },
      {
        "day": "Thursday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 6,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE AFTERNOON SESSION (Chair:  Jan Milewski)"
      },
      {
        "day": "Thursday",
        "eventType": "LECTURE",
        "time": "14:30 - 15:30",
        "dayEventOrderNumber": 7,
        "speaker": "Rasha Abu-Eid",
        "lectureTitle": "The Morphology and Immunology of Head and Neck Cancer",
        "announcement": ""
      },
      {
        "day": "Thursday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 8,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Thursday",
        "eventType": "LECTURE",
        "time": "16:00 - 17:00",
        "dayEventOrderNumber": 9,
        "speaker": "Nebojša Milošević/Veličko Vraneš",
        "lectureTitle": "Monofractal analysis of digital images of the human dentate nucleus: correlation, classification and morphometric analysis",
        "announcement": ""
      },
      {
        "day": "Thursday",
        "eventType": "ANNOUNCEMENT",
        "time": "19:00",
        "dayEventOrderNumber": 10,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "The conference bonfire party"
      },
      {
        "day": "Friday",
        "eventType": "ANNOUNCEMENT",
        "time": "8:00",
        "dayEventOrderNumber": 0,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Breakfast"
      },
      {
        "day": "Friday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 1,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE MORNING SESSION (Chair: Tomasz Pawłowski)"
      },
      {
        "day": "Friday",
        "eventType": "LECTURE",
        "time": "9:00 - 10:00",
        "dayEventOrderNumber": 2,
        "speaker": "Dorota Blinkiewicz",
        "lectureTitle": "Commensurability principles for algebraic tori with examples",
        "announcement": ""
      },
      {
        "day": "Friday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 3,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Coffee break"
      },
      {
        "day": "Friday",
        "eventType": "LECTURE",
        "time": "10:30 - 11:30",
        "dayEventOrderNumber": 4,
        "speaker": "Herbert Jelinek (presented by Helmut Ahammer)",
        "lectureTitle": "Temporal 3-dimensional spatial analysis of Centre of Mass during a postural balance test and effect of Static Taping",
        "announcement": ""
      },
      {
        "day": "Friday",
        "eventType": "ANNOUNCEMENT",
        "time": "",
        "dayEventOrderNumber": 5,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Lunch break (Lunch served at 12:15)"
      },
      {
        "day": "Friday",
        "eventType": "SESSION",
        "time": "",
        "dayEventOrderNumber": 6,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "THE AFTERNOON SESSION (Chair: Grzegorz Banaszak)"
      },
      {
        "day": "Friday",
        "eventType": "LECTURE",
        "time": "14:30 - 15:30",
        "dayEventOrderNumber": 7,
        "speaker": "Przemysław Waliszewski",
        "lectureTitle": "The Fibonacci Constant Limits Self-organization of Epithelial Cells and the Local Connected Fractal Dimension Predicts Their Metastatic Potential",
        "announcement": ""
      },
      {
        "day": "Friday",
        "eventType": "ANNOUNCEMENT",
        "time": "18:30",
        "dayEventOrderNumber": 8,
        "speaker": "",
        "lectureTitle": "",
        "announcement": "Dinner"
      }
    ]
    ;
  }

}



// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/program/program.component.ts